module.exports = __webpack_public_path__ + "img/video12.25f71ed2.jpg";